import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconThumbsUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconThumbsUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ce28e19ff2ce88bcb9de1e0231047a6061c435ac', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '287385d9a12c462eb2fac66cb37393b9b56ce471', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a226e55898abb48390b57447ab64ccfcc38b6049', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 17c.173 0 .337-.08.44-.22 1.33-1.93 2.06-3.14 2.06-5.62a9 9 0 0 0-.33-2.56.49.49 0 0 0-.47-.36c-.264 0-1.424.126-2.53.246-.571.063-1.128.123-1.54.164q.333-1.298.48-2.63c0-1.32-.88-2.01-2.56-2.01-.86 0-1.15.07-1.28.43l-2.14 5.71a1.74 1.74 0 0 0-.13.75v4.35a.47.47 0 0 0 .18.38c1.491 1.281 3.55 1.31 7.293 1.362zm-.5-1.5c-3.96 0-5.08-.18-6-.75v-3.97l1.96-5.27c.85 0 1.15.05 1.15.51 0 .317-.202 1.254-.518 2.722l-.202.938a.477.477 0 0 0 .54.6l4.48-.45q.092.661.09 1.33A6.65 6.65 0 0 1 15 15.5M3.5 9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-thumbs-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-thumbs-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-thumbs-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconThumbsUp$1);
            }
            break;
    } });
}

const CosmosIconThumbsUp = CosmosIconThumbsUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconThumbsUp, defineCustomElement };
